import {NgModule} from '@angular/core';
import {CommonModule,} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {Routes, RouterModule} from '@angular/router';
import {TurumbaAdminLayoutComponent} from './layouts/turumba-admin-layout/turumba-admin-layout.component';
import {TurumbaAuthLayoutComponent} from './layouts/turumba-auth-layout/turumba-auth-layout.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth/login',
        pathMatch: 'full',
    }, {
        path: '',
        component: TurumbaAdminLayoutComponent,
        children: [
            {
                path: 'admin',
                loadChildren: './admin-pages/admin-pages.module#AdminPagesModule'
            }]
    }, {
        path: '',
        component: TurumbaAuthLayoutComponent,
        children: [
            {
                path: 'org',
                loadChildren: './admin-page/admin-page.module#AdminPageModule'
            }]
    }, {
        path: '',
        component: TurumbaAuthLayoutComponent,
        children: [
            {
                path: 'auth',
                loadChildren: './auth-pages/auth-pages.module#AuthPagesModule'
            }]
    }
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes)
    ],
    exports: [],
})
export class AppRoutingModule {
}
